export const LOCALHOST = '127.0.0.1';

export const TIMEOUT = 5000;
